import { ApiDataModel, ApiModule } from '@/api/apiConstants'

const groupPrefix = createApiRoute(ApiModule.DIETARY, ApiDataModel.COMPONENTS)

export const apiDietComponents = {
	fetchComponentByQuery: async (
		{ query, queryType = EDietSearchComponentsFilter.NAME }: IDietaryFetchComponentQuery,
		{ filters, extend, isExcludeNestedSemiProducts }: IDietaryFetchComponentOptions,
	): Promise<IDietComponentsModel> => {
		const extendAsString = getStringFromObject(extend)
		const search = { [queryType]: query }

		const { data } = await apiCommon<IDietComponents>(`${groupPrefix}`, {
			method: 'GET',
			...createQuery(null, { ...search, ...filters }, undefined, {
				exclude_nested_semi_products: isExcludeNestedSemiProducts || undefined,
				extend: extendAsString,
			}),
		})

		return Components(data)
	},
}
